<script>
import BackToTopBtn from '@rei/back-to-top-btn';
import ResultPageComponent from '../../components/search/ResultPageComponent.vue';
import backToTop from '../../mixins/backToTop';
import search from '../../mixins/search/search';
import { FETCH_DATA } from '../../stores/opoSearch/actions/_types';

export default {
  name: 'SearchPageComponent',
  components: {
    ResultPageComponent,
    BackToTopBtn,
  },
  mixins: [backToTop, search],
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      required: true,
    },
    canonical: {
      type: String,
      required: true,
    },
    search: {
      type: Object,
      required: true,
    },
    breadcrumbs: {
      type: Object,
      required: true,
    },
    /**
     * The query string may or may not contain the location coordinates
     */
    locationCoordinates: {
      type: String,
      required: false,
      default: null,
    },
    /**
     * The query string may or may not contain the location coordinates
     */
    queryString: {
      type: String,
      required: false,
      default: null,
    },
  },
  asyncData: ({ store: { dispatch } }) => dispatch(`opo-search/${FETCH_DATA}`),
  head() {
    return this.metaInfo;
  },
  computed: {
    resultPage() {
      return {
        datePicker: this.datePicker(this),
        location: this.location(this),
        collapsableLinkList: this.collapsableLinkList(this),
        search: this.computedSearch(this),
        results: this.results(this),
        noResults: this.noResults(this),
        isLoading: this.isLoading,
      };
    },
  },
};
</script>

<template>
  <main class="search-page-component">
    <ResultPageComponent v-bind="resultPage" />
    <BackToTopBtn />
  </main>
</template>

<style lang="scss" scoped>
.search-page-component {
  position: relative;
}
</style>
